<p class="day-slot-text hand" (click)="select()" id="{{id}}">
    {{calendarTimeAsString()}}
</p>


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/garage/leasing/presentation/userReservation/calendar/slot/daySlot/daySlot.html